module.exports = __webpack_public_path__ + "static/media/i.e01fca83.svg";